{
  "remove": "إزالة"
}
